import { Api } from "../../Api/Api";
export const loginApi = (data, fireBaseToken) =>{
    return(
        Api.post("api/Login", data, {
          headers: { device_type: "web", firebase_token: fireBaseToken },
        })
    )
}
